import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=63cea160&scoped=true"
import script from "./LayoutBlank.vue?vue&type=script&lang=js"
export * from "./LayoutBlank.vue?vue&type=script&lang=js"
import style0 from "./LayoutBlank.vue?vue&type=style&index=0&id=63cea160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cea160",
  null
  
)

export default component.exports